<div class="mx-auto flex w-full min-w-0 max-w-full flex-auto flex-col p-3 sm:p-4 md:p-5 lg:p-6 xl:p-7 2xl:p-8">
  <!-- Card principal -->
  <div class="bg-card flex min-h-0 min-w-0 w-full max-w-full flex-auto flex-col overflow-hidden rounded-2xl p-4 shadow sm:p-6 dark:bg-transparent">
    <form [formGroup]="formData" class="w-full">
      <div class="grid w-full grid-cols-1 gap-x-8 gap-y-8 lg:grid-cols-2">
        <!-- Datos generales -->
        <section class="w-full">
          <div class="flex items-center justify-between">
            <h3 class="section-title">{{ 'DOCUMENT_GENERATE.SECTIONS.GENERAL_DATA' | t }}</h3>
            <!-- en una sola columna esta es la sección de arriba: el reinicio va aquí -->
            @if (!screenIsWide) {
            <div class="-my-2 -mr-2 flex items-center">
              <button mat-icon-button color="primary" type="button"
                [matTooltip]="'DOCUMENT_GENERATE.ACTIONS.ACTIONS_MENU' | t" [matMenuTriggerFor]="dgActionsMenu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #dgActionsMenu="matMenu">
                <button mat-menu-item type="button" (click)="openMyDailyTransactions()">
                  <mat-icon>calendar_today</mat-icon>
                  <span>{{ 'DOCUMENT_GENERATE.ACTIONS.MY_DAILY_TRANSACTIONS' | t }}</span>
                </button>
                <button mat-menu-item type="button" [disabled]="!shipToSelected"
                  (click)="openBusinessPartnerOpenItems()">
                  <mat-icon>account_balance_wallet</mat-icon>
                  <span>{{ 'DOCUMENT_GENERATE.ACTIONS.PARTNER_OPEN_ITEMS' | t }}</span>
                </button>
                <button mat-menu-item type="button" (click)="resetForm()">
                  <mat-icon>refresh</mat-icon>
                  <span>{{ 'DOCUMENT_GENERATE.ACTIONS.RESET' | t }}</span>
                </button>
              </mat-menu>
            </div>
            }
          </div>
          <div class="section-line"></div>

          <div class="mt-4 grid grid-cols-1 items-start gap-x-4 gap-y-2 sm:grid-cols-2 md:grid-cols-3">
            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_TYPE' | t }}</mat-label>
              <mat-select [formControl]="documentTypeControl" required
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_TYPE' | t"
                (selectionChange)="onDocumentTypeChange()">
                <mat-option *ngFor="let type of documentTypeOptions" [value]="type.value" class="text-content">
                  {{ documentTypeLabel(type.value) }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="dg-wrap-field w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_CLASS' | t }}</mat-label>
              <textarea #classTrigger="matAutocompleteTrigger"
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_CLASS' | t"
                [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.DOCUMENT_CLASS' | t" matInput required rows="1"
                cdkTextareaAutosize spellcheck="false" (keydown.enter)="$event.preventDefault()"
                [formControl]="documentClassControl" [matAutocomplete]="autoDocClass"></textarea>
              <mat-autocomplete #autoDocClass="matAutocomplete" [displayWith]="displayDocumentClass"
                class="dg-wrap-panel" (optionSelected)="onDocumentClassChange()">
                <mat-option *ngFor="let documentClass of filteredDocumentClasses()" [value]="documentClass._id" class="text-content">
                  {{ optionLabel(documentClass) }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="documentClassControl.hasError('required')">
                {{ (documentTypeControl.value ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_DOCUMENT_TYPE_FIRST') | t }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full sm:col-span-2 md:col-span-1">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</mat-label>
              <input type="text" [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_OFFICE' | t" [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t" matInput
                [formControl]="salesOfficeControl" [matAutocomplete]="autoSalesOffice">
              <mat-autocomplete #autoSalesOffice="matAutocomplete" [displayWith]="displaySalesOffice"
                class="dg-wrap-panel" (optionSelected)="onSalesOfficeManualChange()">
                <mat-option *ngFor="let salesOffice of filteredSalesOffices()" [value]="salesOffice._id" class="text-content">
                  {{ optionLabel(salesOffice) }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="!shipToSelected">{{ 'DOCUMENT_GENERATE.MESSAGES.OFFICE_AUTOFILL_HINT' | t }}</mat-hint>
            </mat-form-field>

            <mat-form-field class="w-full sm:col-span-2 md:col-span-3">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SHIP_TO' | t }}</mat-label>
              <button matPrefix mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.ACTIONS.SEARCH_SHIP_TO' | t"
                [disabled]="!documentClassSelected" (mousedown)="$event.preventDefault()"
                (click)="shipToTrigger.closePanel(); shipToInput.blur(); openShipToSearch()">
                <mat-icon>person_search</mat-icon>
              </button>
              <input type="text" #shipToInput #shipToTrigger="matAutocompleteTrigger"
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_SHIP_TO' | t"
                [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.SHIP_TO' | t" matInput
                [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
              <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName"
                (optionSelected)="onInlineShipToSelected()">
                @if (shipToSearchLoading) {
                <!-- el listado resuelve en remoto: el skeleton avisa que la búsqueda va en camino -->
                <mat-option disabled class="dg-search-status">
                  <div class="flex w-full flex-col gap-2 py-1">
                    <div class="h-3 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
                    <div class="h-3 w-1/2 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
                    <div class="h-3 w-2/3 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
                  </div>
                </mat-option>
                } @else {
                @for (shipTo of shipToList; track shipTo) {
                <mat-option [value]="shipTo._id" class="text-content">
                  {{ shipToLabel(shipTo) }}
                </mat-option>
                }
                }
              </mat-autocomplete>
              <mat-hint *ngIf="!documentClassSelected || clientPriceListLabel()">
                <span *ngIf="!documentClassSelected" style="color: var(--fuse-warn);">{{ 'DOCUMENT_GENERATE.MESSAGES.SHIP_TO_REQUIRES_CLASS' | t }}</span>
                <span *ngIf="documentClassSelected">{{ 'DOCUMENT_GENERATE.FIELDS.PRICE_LIST' | t }}: {{ clientPriceListLabel() }}</span>
              </mat-hint>
              <mat-error *ngIf="shipToControl.hasError('required')">{{ 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' | t }}</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full sm:col-span-2 md:col-span-3">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SOLD_TO' | t }}</mat-label>
              <input matInput readonly [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_SHIP_TO_FIRST' | t"
                [value]="soldToLabel()">
            </mat-form-field>

            <mat-form-field class="dg-address-field w-full sm:col-span-2 md:col-span-3">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SHIPPING_ADDRESS' | t }}</mat-label>
              <mat-select [formControl]="addressControl" [required]="addressRequired" [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_ADDRESS' | t"
                panelClass="dg-address-panel" (selectionChange)="onAddressChange()">
                <mat-select-trigger>
                  <span class="dg-address-trigger">{{ (addressSelected?.externalKeys?.code || addressSelected?.code) ? (addressSelected?.externalKeys?.code || addressSelected?.code) + ' - ' : '' }}{{ addressSelected?.address }}</span>
                </mat-select-trigger>
                <mat-option *ngFor="let address of addressesList" [value]="address._id" class="text-content dg-address-option">
                  {{ (address?.externalKeys?.code || address?.code) ? (address?.externalKeys?.code || address?.code) + ' - ' : '' }}{{ address.address }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="addressControl.hasError('required')">
                {{ (shipToSelected ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SHIP_TO_FIRST') | t }}
              </mat-error>
            </mat-form-field>
          </div>
        </section>

        <!-- Logistica -->
        <section class="w-full">
          <div class="flex items-center justify-between">
            <h3 class="section-title">{{ 'DOCUMENT_GENERATE.SECTIONS.LOGISTICS' | t }}</h3>
            <!-- en dos columnas esta es la sección de la derecha: el reinicio va aquí -->
            @if (screenIsWide) {
            <div class="-my-2 -mr-2 flex items-center gap-1">
              <button mat-icon-button color="primary" type="button"
                [matTooltip]="'DOCUMENT_GENERATE.ACTIONS.MY_DAILY_TRANSACTIONS' | t"
                (click)="openMyDailyTransactions()">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <button mat-icon-button color="primary" type="button"
                [matTooltip]="'DOCUMENT_GENERATE.ACTIONS.PARTNER_OPEN_ITEMS' | t"
                [disabled]="!shipToSelected" (click)="openBusinessPartnerOpenItems()">
                <mat-icon>account_balance_wallet</mat-icon>
              </button>
              <button mat-icon-button color="primary" type="button"
                [matTooltip]="'DOCUMENT_GENERATE.ACTIONS.RESET' | t" (click)="resetForm()">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
            }
          </div>
          <div class="section-line"></div>

          <div class="mt-4 grid grid-cols-1 items-start gap-x-4 gap-y-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-2">
            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.WAREHOUSE' | t }}</mat-label>
              <input type="text" [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_WAREHOUSE' | t"
                [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.WAREHOUSE' | t" matInput required
                [formControl]="warehouseControl" [matAutocomplete]="autoWarehouse">
              <mat-autocomplete #autoWarehouse="matAutocomplete" [displayWith]="displayWarehouse"
                class="dg-wrap-panel" (optionSelected)="onWarehouseChange()">
                @for (warehouse of filteredWarehouses(); track warehouse._id) {
                <mat-option [value]="warehouse._id" class="text-content">
                  {{ optionLabel(warehouse) }}
                </mat-option>
                }
              </mat-autocomplete>
              <mat-error *ngIf="warehouseControl.hasError('required')">
                {{ (salesOfficeSelected ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SALES_OFFICE_FIRST') | t }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.EXPEDITION_CONDITION' | t }}</mat-label>
              <mat-select [formControl]="expeditionConditionControl" [required]="expeditionConditionRequired"
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_EXPEDITION_CONDITION' | t"
                (selectionChange)="onExpeditionConditionChange()" [disabled]="expeditionConditionDisabled">
                <mat-option *ngFor="let expeditionCondition of expeditionConditionsList" [value]="expeditionCondition._id" class="text-content">
                  {{ expeditionCondition.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="expeditionConditionControl.hasError('required')">
                {{ (documentClassSelected ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_DOCUMENT_CLASS_FIRST') | t }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.PAYMENT_CONDITION' | t }}</mat-label>
              <mat-select [formControl]="paymentConditionControl" required
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_PAYMENT_CONDITION' | t"
                (selectionChange)="onPaymentConditionChange()" [disabled]="paymentConditionDisabled">
                <mat-option *ngFor="let paymentCondition of paymentConditionsFilterList" [value]="paymentCondition._id" class="text-content">
                  {{ paymentCondition?.externalKeys?.code }} - {{ paymentCondition.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="paymentConditionControl.hasError('required')">
                {{ (shipToSelected ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SHIP_TO_FIRST') | t }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.REFERENCE' | t }}</mat-label>
              <input type="text" [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.ENTER_REFERENCE' | t"
                [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.REFERENCE' | t" matInput
                [formControl]="referenceControl">
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DOCUMENT_DATE' | t }}</mat-label>
              <input matInput readonly [value]="documentDateControl.value | date:'dd/MM/yyyy'">
              <mat-icon matIconSuffix>event</mat-icon>
            </mat-form-field>

            @if (deliveryRouteLoading) {
            <div class="flex w-full animate-pulse flex-col gap-2 pt-2">
              <div class="h-3 w-1/3 rounded bg-gray-200 dark:bg-gray-700"></div>
              <div class="h-10 w-full rounded bg-gray-200 dark:bg-gray-700"></div>
            </div>
            } @else {
            <mat-form-field class="w-full" subscriptSizing="dynamic">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_ROUTE' | t }}</mat-label>
              <mat-select [formControl]="deliveryRouteControl" [required]="deliveryRouteRequired"
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_ROUTE' | t"
                (selectionChange)="onDeliveryRouteChange()">
                @for (deliveryRoute of deliveryRouteList; track deliveryRoute._id) {
                <mat-option [value]="deliveryRoute._id" class="text-content">
                  {{ deliveryRoute.name }}
                </mat-option>
                }
              </mat-select>
              <mat-hint *ngIf="deliveryTripLabel() as tripLabel" class="dg-trip-hint" [matTooltip]="tripLabel">
                {{ tripLabel }}
              </mat-hint>
              <mat-error *ngIf="deliveryRouteControl.hasError('required')">
                {{ (shipToSelected ? 'DOCUMENT_GENERATE.MESSAGES.FIELD_REQUIRED' : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SHIP_TO_FIRST') | t }}
              </mat-error>
            </mat-form-field>
            }

            <!-- las tres fechas comparten fila: ocupan el ancho del grupo y se reparten en tres -->
            <div class="grid grid-cols-1 items-start gap-x-4 gap-y-2 sm:col-span-2 sm:grid-cols-3 md:col-span-3 lg:col-span-2">
              <mat-form-field class="w-full">
                <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.LOAD_DATE' | t }}</mat-label>
                <input matInput readonly [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.LOAD_DATE_FROM_ROUTE' | t"
                  [value]="chargeDateControl.value | date:'dd/MM/yyyy'">
                <mat-icon matIconSuffix>event</mat-icon>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_DATE' | t }}</mat-label>
                <input matInput readonly [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.DELIVERY_DATE_FROM_ROUTE' | t"
                  [value]="deliveryDateControl.value | date:'dd/MM/yyyy'">
                <mat-icon matIconSuffix>event_available</mat-icon>
              </mat-form-field>

              <mat-form-field class="w-full">
                <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DELIVERY_HOUR' | t }}</mat-label>
                <mat-icon matSuffix>schedule</mat-icon>
                <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SELECT_TIME' | t"
                  [attr.aria-label]="'DOCUMENT_GENERATE.FIELDS.DELIVERY_HOUR' | t"
                  [formControl]="deliveryHourControl" [ngxTimepicker]="deliveryTimePicker" />
                <ngx-material-timepicker #deliveryTimePicker></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>
        </section>
      </div>
      <ng-template #suggestionsTpl>
          <mat-tab-group class="dg-suggestions-tabs flex min-h-0 flex-1 flex-col" animationDuration="0ms">

            <!-- Histórico de documentos -->
            <mat-tab [label]="'DOCUMENT_GENERATE.TABS.DOCUMENT_HISTORY' | t">
              <div class="flex h-full min-h-0 flex-col">
                <div class="dg-suggest-filters flex flex-col gap-2 pb-2 sm:flex-row">
                  <mat-form-field class="w-full sm:w-1/2" subscriptSizing="dynamic">
                    <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DATE_RANGE' | t }}</mat-label>
                    <mat-select [(ngModel)]="docDays" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="onDocumentsFilterChange()">
                      @for (d of suggestedDaysOptions; track d) {
                      <mat-option [value]="d">{{ 'DOCUMENT_GENERATE.SUGGESTIONS.LAST_DAYS' | t: { days: d } }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-full sm:w-1/2" subscriptSizing="dynamic">
                    <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</mat-label>
                    <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.ALL_FEMININE' | t"
                      [matAutocomplete]="autoDocOffice" [(ngModel)]="docOfficeSearch"
                      [ngModelOptions]="{ standalone: true }" [disabled]="!shipToSelected"
                      (ngModelChange)="onDocOfficeInput()">
                    @if (docOfficeSearch) {
                    <button matSuffix mat-icon-button type="button" (click)="docOfficeSearch = ''; onDocOfficeInput()">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <mat-autocomplete #autoDocOffice="matAutocomplete" (optionSelected)="onDocOfficeSelected($event.option.value)">
                      @for (o of filteredSuggestOffices(docOfficeSearch); track o._id) {
                      <mat-option [value]="o.name">{{ o.name }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="pb-2">
                  <mat-form-field class="w-full" subscriptSizing="dynamic">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_DOCUMENT_OR_ERP' | t" [(ngModel)]="docSearch"
                      [ngModelOptions]="{ standalone: true }" [disabled]="!shipToSelected"
                      (keydown.enter)="onDocSearch()">
                    @if (docSearch) {
                    <button matSuffix mat-icon-button type="button" (click)="docSearch = ''; onDocSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                  </mat-form-field>
                </div>
                <div class="min-h-0 flex-1 overflow-hidden">
                  <app-order-history-tab [orders]="orderHistoryList" [loading]="suggestedLoading"
                    [emptyMessage]="(shipToSelected
                      ? (docSearch.trim() ? 'DOCUMENT_GENERATE.MESSAGES.NO_RESULTS' : 'DOCUMENT_GENERATE.MESSAGES.NO_SUGGESTED_ORDERS')
                      : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SHIP_TO_EMPTY_HINT') | t"
                    (view)="onViewOrderHistory($event)"></app-order-history-tab>
                </div>
                <div class="flex items-center justify-between border-t px-1 py-1">
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SUGGESTIONS.ORDERS_COUNT' | t: { count: documentsCount } }}</span>
                  <div class="flex items-center gap-1">
                    <button mat-icon-button type="button" [disabled]="documentsPage <= 1 || suggestedLoading"
                      (click)="changeDocumentsPage(-1)">
                      <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="text-secondary text-xs">{{ documentsPage }} / {{ documentsTotalPages }}</span>
                    <button mat-icon-button type="button"
                      [disabled]="documentsPage >= documentsTotalPages || suggestedLoading" (click)="changeDocumentsPage(1)">
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Productos Sugeridos -->
            <mat-tab [label]="'DOCUMENT_GENERATE.TABS.SUGGESTED_PRODUCTS' | t">
              <div class="flex h-full min-h-0 flex-col">
                <div class="dg-suggest-filters flex flex-col gap-2 pb-2 sm:flex-row">
                  <mat-form-field class="w-full sm:w-1/2" subscriptSizing="dynamic">
                    <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.DATE_RANGE' | t }}</mat-label>
                    <mat-select [(ngModel)]="prodDays" [ngModelOptions]="{ standalone: true }"
                      (selectionChange)="onProductsFilterChange()">
                      @for (d of suggestedDaysOptions; track d) {
                      <mat-option [value]="d">{{ 'DOCUMENT_GENERATE.SUGGESTIONS.LAST_DAYS' | t: { days: d } }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-full sm:w-1/2" subscriptSizing="dynamic">
                    <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.SALES_OFFICE' | t }}</mat-label>
                    <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.ALL_FEMININE' | t"
                      [matAutocomplete]="autoProdOffice" [(ngModel)]="prodOfficeSearch"
                      [ngModelOptions]="{ standalone: true }" [disabled]="!shipToSelected"
                      (ngModelChange)="onProdOfficeInput()">
                    @if (prodOfficeSearch) {
                    <button matSuffix mat-icon-button type="button" (click)="prodOfficeSearch = ''; onProdOfficeInput()">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                    <mat-autocomplete #autoProdOffice="matAutocomplete" (optionSelected)="onProdOfficeSelected($event.option.value)">
                      @for (o of filteredSuggestOffices(prodOfficeSearch); track o._id) {
                      <mat-option [value]="o.name">{{ o.name }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div class="pb-2">
                  <mat-form-field class="w-full" subscriptSizing="dynamic">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.SEARCH_NAME_OR_CODE' | t" [(ngModel)]="prodSearch"
                      [ngModelOptions]="{ standalone: true }" [disabled]="!shipToSelected"
                      (keydown.enter)="onProdSearch()">
                    @if (prodSearch) {
                    <button matSuffix mat-icon-button type="button" (click)="prodSearch = ''; onProdSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                    }
                  </mat-form-field>
                </div>
                <div class="min-h-0 flex-1 overflow-hidden">
                  <app-suggested-products-tab [products]="suggestedProductsList" [loading]="suggestedLoading"
                    [umpActive]="company?.UMPActive !== false"
                    [emptyMessage]="(shipToSelected
                      ? (prodSearch.trim() ? 'DOCUMENT_GENERATE.MESSAGES.NO_RESULTS' : 'DOCUMENT_GENERATE.MESSAGES.NO_SUGGESTED_PRODUCTS')
                      : 'DOCUMENT_GENERATE.MESSAGES.SELECT_SHIP_TO_EMPTY_HINT') | t"
                    (add)="onAddSuggestedProduct($event)"></app-suggested-products-tab>
                </div>
                <div class="flex items-center justify-between border-t px-1 py-1">
                  <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.SUGGESTIONS.PRODUCTS_COUNT' | t: { count: productsCount } }}</span>
                  <div class="flex items-center gap-1">
                    <button mat-icon-button type="button" [disabled]="productsPage <= 1 || suggestedLoading"
                      (click)="changeProductsPage(-1)">
                      <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span class="text-secondary text-xs">{{ productsPage }} / {{ productsTotalPages }}</span>
                    <button mat-icon-button type="button"
                      [disabled]="productsPage >= productsTotalPages || suggestedLoading" (click)="changeProductsPage(1)">
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </mat-tab>

          </mat-tab-group>
      </ng-template>

      <ng-template #suggestionsDialogTpl>
        <div class="flex h-full min-h-0 w-full flex-col">
          <div class="flex items-center justify-between px-4 pt-4">
            <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.SECTIONS.SUGGESTIONS' | t }}</h2>
            <button mat-icon-button type="button" (click)="closeSuggestionsPanel()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="flex min-h-0 flex-1 flex-col px-2 pb-3 pt-2">
            <ng-container *ngTemplateOutlet="suggestionsTpl"></ng-container>
          </div>
        </div>
      </ng-template>

      <div class="mt-8 flex w-full flex-col gap-6 lg:h-[clamp(580px,72vh,800px)] lg:flex-row">
      @if (screenIsWide) {
        @if (suggestionsExpanded) {
        <div class="flex w-full min-w-0 flex-col lg:w-1/3">
          <h3 class="section-title cursor-pointer select-none" (click)="toggleSuggestions()">
            <mat-icon class="mr-1 align-middle text-sm">expand_more</mat-icon>
            {{ 'DOCUMENT_GENERATE.SECTIONS.SUGGESTIONS' | t }}
          </h3>
          <div class="section-line mb-3"></div>

          <div class="flex min-h-0 flex-1 flex-col rounded-2xl bg-gray-50 px-2 py-1 dark:bg-transparent">
            <ng-container *ngTemplateOutlet="suggestionsTpl"></ng-container>
          </div>
        </div>
        } @else {
        <!-- colapsado: solo queda la franja con el título al borde del formulario -->
        <div class="dg-suggestions-rail flex w-auto shrink-0 cursor-pointer select-none flex-col items-center justify-start gap-1 rounded-lg border px-2 py-3"
          [matTooltip]="'DOCUMENT_GENERATE.SUGGESTIONS.SHOW' | t" (click)="toggleSuggestions()">
          <mat-icon class="text-secondary icon-size-5">chevron_right</mat-icon>
          <span class="dg-suggestions-rail-label text-[15px] font-bold">{{ 'DOCUMENT_GENERATE.SECTIONS.SUGGESTIONS' | t }}</span>
        </div>
        }
      }

      <div class="flex min-w-0 flex-1 flex-col">
        <app-items-table class="flex min-h-0 flex-1 flex-col" [items]="items" [canAdd]="!!shipToSelected"
          [editablePrice]="canUpdatePrices" [taxIncluded]="taxIncluded" [compact]="screenIsSmall"
          [showSuggestions]="!screenIsWide" [searchResults]="itemSearchResults"
          [searchLoading]="itemSearchLoading"
          [removeLeftZeros]="!!documentClassSelected?.removeLeftZerosOfMaterial"
          [allowMultipleWarehouses]="allowsMultipleWarehousesInView"
          [splitsByWarehouse]="splitsByWarehouseInView"
          [umpActive]="company?.UMPActive !== false"
          (searchTermChange)="onItemSearchTerm($event)" (selectResult)="onItemSearchSelect($event)"
          (openSearch)="openProductSearch('')" (openSuggestions)="openSuggestionsPanel()"
          (add)="onItemsAdd($event)" (expand)="openOrderItems()" (changeUnit)="onChangeUnit($event)"
          (quantityChange)="onItemQuantityChange($event)" (priceChange)="onItemPriceChange($event)"
          (openCalculator)="onOpenCalculator($event)" (openDetail)="onOpenDetail($event)"
          (openWarehouses)="onOpenWarehouseDistribution($event)"
          (remove)="onRemoveItem($event)"></app-items-table>
      </div>
      </div>

      <div class="mt-8 grid w-full grid-cols-1 items-stretch gap-x-8 gap-y-8 md:grid-cols-2">
        <section class="flex w-full flex-col">
          <h3 class="section-title">{{ 'DOCUMENT_GENERATE.SECTIONS.NOTES_ATTACHMENTS' | t }}</h3>
          <div class="section-line"></div>
          <div class="mt-4 flex flex-1 flex-col gap-4 rounded-2xl bg-gray-50 p-4 dark:bg-transparent">
            <mat-form-field class="w-full">
              <mat-label>{{ 'DOCUMENT_GENERATE.FIELDS.NOTES' | t }}</mat-label>
              <textarea matInput rows="5" maxlength="900"
                [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.NOTES' | t"
                [formControl]="comentariesControl"></textarea>
              <mat-hint align="end">{{ comentariesControl.value?.length || 0 }}/900</mat-hint>
            </mat-form-field>

            <app-attachment-input class="dg-uploader-only" [config]="attachmentConfig"
              [formControl]="attachmentsControl"></app-attachment-input>
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.MESSAGES.MAX_FILES' | t: { max: MAX_ATTACHMENTS } }}</span>
          </div>
        </section>

        <section class="flex w-full flex-col">
          <h3 class="section-title">{{ 'DOCUMENT_GENERATE.SECTIONS.SUMMARY' | t }}</h3>
          <div class="section-line"></div>
          <div class="mt-4 flex-1 rounded-2xl bg-gray-50 p-4 dark:bg-transparent">
            <p class="text-secondary mb-4 text-sm">{{ 'DOCUMENT_GENERATE.SUMMARY.ITEMS_SELECTED' | t: { count: summary.itemsCount } }}</p>
            <div class="flex flex-col gap-3">
              <div class="flex items-center gap-3 rounded-xl border bg-card p-4">
                <mat-icon class="text-primary" fontSet="material-icons-outlined">inventory_2</mat-icon>
                <span class="text-secondary flex-1 text-sm font-medium">{{ 'DOCUMENT_GENERATE.SUMMARY.SUBTOTAL' | t }}</span>
                <span class="font-semibold">L.&nbsp;{{ summary.subtotal | dgNumber }}</span>
              </div>
              <div class="flex items-center gap-3 rounded-xl border bg-card p-4">
                <mat-icon class="text-primary" fontSet="material-icons-outlined">sell</mat-icon>
                <span class="text-secondary flex-1 text-sm font-medium">{{ 'DOCUMENT_GENERATE.SUMMARY.DISCOUNT' | t }}</span>
                <span class="font-semibold text-green-600">-L.&nbsp;{{ summary.discount | dgNumber }}</span>
              </div>
              <div class="flex items-center gap-3 rounded-xl border bg-card p-4">
                <mat-icon class="text-primary" fontSet="material-icons-outlined">receipt_long</mat-icon>
                <span class="text-secondary flex-1 text-sm font-medium">{{ 'DOCUMENT_GENERATE.SUMMARY.TAX' | t }}</span>
                <span class="font-semibold">L.&nbsp;{{ summary.taxes | dgNumber }}</span>
              </div>
              <div class="flex items-center gap-3 rounded-xl border-2 border-primary bg-primary-50 p-4 dark:bg-primary-900/10">
                <mat-icon class="text-primary" fontSet="material-icons-outlined">payments</mat-icon>
                <span class="text-primary flex-1 text-sm font-semibold">{{ 'DOCUMENT_GENERATE.SUMMARY.TOTAL' | t }}</span>
                <span class="text-primary text-lg font-bold">L.&nbsp;{{ summary.total | dgNumber }}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </form>

    @if (attachmentFiles.length) {
    <div class="mt-6 w-full">
      <h3 class="section-title">{{ 'DOCUMENT_GENERATE.SECTIONS.ATTACHED_FILES' | t: { count: attachmentFiles.length, max: MAX_ATTACHMENTS } }}</h3>
      <div class="section-line mb-4"></div>
      <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        @for (file of attachmentFiles; track $index; let i = $index) {
        <div class="flex items-center gap-2 rounded-lg border bg-gray-50 px-3 py-2 dark:bg-transparent">
          <mat-icon class="text-secondary icon-size-5 shrink-0">insert_drive_file</mat-icon>
          <div class="flex min-w-0 flex-1 flex-col">
            <span class="truncate text-sm font-medium" [matTooltip]="file.name">{{ file.name }}</span>
            <span class="text-secondary text-xs">{{ formatFileSize(file.size) }}</span>
          </div>
          <button mat-icon-button color="warn" type="button" class="shrink-0" (click)="removeAttachment(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        }
      </div>
    </div>
    }

    <div class="mt-8 flex flex-col justify-end gap-3 border-t pt-6 sm:flex-row">
      <button mat-stroked-button color="primary" type="button" (click)="onPrintProforma()">
        <mat-icon>print</mat-icon>
        {{ 'DOCUMENT_GENERATE.ACTIONS.PRINT_PROFORMA' | t }}
      </button>
      <!-- TODO: Para la version dos se implementara el uso de borrador -->
      <!-- <button mat-stroked-button color="primary" type="button">
        <mat-icon>save</mat-icon>
        Borrador
      </button> -->
      <button
        mat-flat-button
        color="primary"
        type="button"
        [matMenuTriggerFor]="generateMenu"
        [disabled]="!items.length || submitting || deliveryRouteLoading"
      >
        <mat-icon>send</mat-icon>
        {{ (submitting ? 'DOCUMENT_GENERATE.ACTIONS.GENERATING' : 'DOCUMENT_GENERATE.ACTIONS.GENERATE') | t }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #generateMenu="matMenu">
        <button mat-menu-item type="button" (click)="onGenerateReview()">
          <mat-icon>visibility</mat-icon>
          <span>{{ 'DOCUMENT_GENERATE.ACTIONS.GENERATE_AND_REVIEW' | t }}</span>
        </button>
        <button mat-menu-item type="button" (click)="onGenerateNew()">
          <mat-icon>add</mat-icon>
          <span>{{ 'DOCUMENT_GENERATE.ACTIONS.GENERATE_AND_NEW' | t }}</span>
        </button>
        <button mat-menu-item type="button" (click)="onGenerateNewSameClient()">
          <mat-icon>person_add</mat-icon>
          <span>{{ 'DOCUMENT_GENERATE.ACTIONS.GENERATE_AND_NEW_SAME_CLIENT' | t }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
